import * as mutationType from "../mutation_types";

const state = {
  core_coaches: [],
  core_coach: {},
  customers: []
};

const getters = {
  core_coaches: state => state.core_coaches,
  core_coach: state => state.core_coach,
  customers: state => state.customers
};

const actions = {
  getCoreCoaches({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/corecoaches`)
        .then(res => {
          commit(mutationType.SET_CORE_COACHES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCoreCoach({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/corecoaches/${id}`)
        .then(res => {
          commit(mutationType.SET_CORE_COACH, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCustomers({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/corecoaches/${id}/customers`)
        .then(res => {
          commit(mutationType.SET_CORE_COACH_CUSTOMERS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  assignCoreCoach({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/corecoaches/${id}`)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  unassignCoreCoach({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/corecoaches/${id}`)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_CORE_COACHES](state, list) {
    state.core_coaches = list;
  },
  [mutationType.SET_CORE_COACH](state, item) {
    state.core_coach = item;
  },
  [mutationType.SET_CORE_COACH_CUSTOMERS](state, list) {
    state.customers = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
